<template>
  <div @mouseleave="params.colDef.CellRendererParams.leavingMouse(params.data)">
    <ul class="flex" v-if="!params.data.attendance_marked">
      <li class="mr-2">
        <vs-radio
          v-model="params.data.attendance"
          :vs-name="`attendance${params.rowIndex}`"
          :vs-value="true"
          @change="params.colDef.CellRendererParams.markingAttendance(true, params.data)"
          :disabled="params.colDef.CellRendererParams.edit_permission() ? false : true"
        >
          Present</vs-radio
        >
        <vs-input
          v-if="params.data.attendance"
          style="width: 100px"
          type="number"
          placeholder="Delayed by"
          min="1"
          max="120"
          v-model="params.data.delay_in_minutes"
          @keyup.enter="
            params.colDef.CellRendererParams.markingAttendance(
              true,
              params.data,
              'delayed',
              $event
            )
          "
        />
      </li>
      <li class="mr-2">
        <vs-radio
          v-model="params.data.attendance"
          :vs-name="`attendance${params.rowIndex}`"
          :vs-value="false"
          @change="params.colDef.CellRendererParams.markingAttendance(false, params.data)"
          :disabled="params.colDef.CellRendererParams.edit_permission() ? false : true"
          >Absent</vs-radio
        >
      </li>
    </ul>
    <div v-else class="flex items-center">
      <span
        class="attendance-badge"
        :class="params.data.attendance ? 'present' : 'absent'"
      >
        {{ params.data.attendance ? "Present" : "Absent" }}
      </span>
      <a
        v-if="params.colDef.CellRendererParams.edit_permission()"
        class="material-icons edit_att"
        @click="params.colDef.CellRendererParams.editAttendance(params.data)"
        >edit</a
      >
    </div>
    <!-- {{params.data.delay_in_minutes}} -->
    <small
      v-if="
        params.data.delay_in_minutes &&
        params.data.attendance_marked &&
        params.data.attendance
      "
      style="color: gray; font-weight: 600"
      >Delayed by: {{ params.data.delay_in_minutes }} mins</small
    >
  </div>
</template>

<script>
export default {
  name: 'AttendanceCell'
}
</script>